export default __webpack_public_path__ + "src/images/packages/the-coconut-shell/857ebfbd5bb18e4c57cd5e694441d142-4.jpg";